import { render, staticRenderFns } from "./survey-insights.vue?vue&type=template&id=1b7c5b4a&scoped=true"
import script from "./survey-insights.vue?vue&type=script&lang=js"
export * from "./survey-insights.vue?vue&type=script&lang=js"
import style0 from "./survey-insights.vue?vue&type=style&index=0&id=1b7c5b4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c5b4a",
  null
  
)

export default component.exports